/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useEffect, useState } from 'react';

const mouseMovementEvents: (keyof HTMLElementEventMap)[] = [
  'mouseenter',
  'mousedown',
  'mouseleave',
  'mousemove',
  'mouseout',
  'mouseover',
  'mouseup',
  'keydown',
  'keyup',
  'pointermove',
  'pointerdown',
  'pointercancel',
  'pointerenter',
  'pointerleave',
  'pointerout',
  'pointerover',
  'pointerup',

  // All events:
  //   'abort', 'animationcancel', 'animationend', 'animationiteration', 'animationstart', 'auxclick', 'blur', 'cancel',
  //   'canplay', 'canplaythrough', 'change', 'click', 'close', 'contextmenu', 'cuechange', 'dblclick', 'drag', 'dragend',
  //   'dragenter', 'dragexit', 'dragleave', 'dragover', 'dragstart', 'drop', 'durationchange', 'emptied', 'ended', 'error',
  //   'focus', 'focusin', 'focusout', 'gotpointercapture', 'input', 'invalid', 'keydown', 'keypress', 'keyup', 'load',
  //   'loadeddata', 'loadedmetadata', 'loadstart', 'lostpointercapture', 'mousedown', 'mouseenter', 'mouseleave',
  //   'mousemove', 'mouseout', 'mouseover', 'mouseup', 'pause', 'play', 'playing', 'pointercancel', 'pointerdown',
  //   'pointerenter', 'pointerleave', 'pointermove', 'pointerout', 'pointerover', 'pointerup', 'progress', 'ratechange',
  //   'reset', 'resize', 'scroll', 'securitypolicyviolation', 'seeked', 'seeking', 'select', 'selectionchange',
  //   'selectstart', 'stalled', 'submit', 'suspend', 'timeupdate', 'toggle', 'touchcancel', 'touchend', 'touchmove',
  //   'touchstart', 'transitioncancel', 'transitionend', 'transitionrun', 'transitionstart', 'volumechange', 'waiting',
  //   'wheel',
];

export const grayOverlayTestId = 'gray-overlay';

export const GrayOverlay: React.FC = () => {
  const body = document.getElementsByTagName('body')[0];
  const [isGrayedOut, setIsGrayedOut] = useState(true);

  useEffect(() => {
    const mouseEvent = () => {
      if (isGrayedOut) {
        removeMouseEventListeners();
        setIsGrayedOut(false);
      }
    };

    const addMouseEventListeners = () => {
      for (const event of mouseMovementEvents) {
        body.addEventListener(event, mouseEvent);
      }
    };

    const removeMouseEventListeners = () => {
      for (const event of mouseMovementEvents) {
        body.removeEventListener(event, mouseEvent);
      }
    };

    const timeToPreventDisablingGrayOutBeforeOpenerDialogShows = 100;
    const timeout = setTimeout(
      addMouseEventListeners,
      timeToPreventDisablingGrayOutBeforeOpenerDialogShows
    );

    return () => {
      clearTimeout(timeout);
      removeMouseEventListeners();
    };
  });
  return isGrayedOut ? (
    <div
      role='presentation'
      data-testid={grayOverlayTestId}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, .55)',
        zIndex: 1,
      }}
    />
  ) : (
    <React.Fragment />
  );
};
